import React from 'react';

import { ErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary';
import { NewVersionBar } from 'components/NewVersionBar/NewVersionBar';
import AppProviders from 'providers';
import AppRoutes from 'routes';
import 'config/chart-js';

function App() {
  return (
    <AppProviders>
      <ErrorBoundary>
        <NewVersionBar />
        <AppRoutes />
      </ErrorBoundary>
    </AppProviders>
  );
}

export default App;
